module.exports = __webpack_public_path__ + "media/1.3c39d4bc.mp3";